import { navigate } from "gatsby";
import { useShouldRedirectWhenAuthenticated } from "../hooks/common.hooks";

export const AuthenticatedRedirect = ({ redirectTo = "/", children }) => {
  const shouldRedirect = useShouldRedirectWhenAuthenticated();

  if (shouldRedirect) {
    navigate(redirectTo);
    // Return null to prevent flash of children during redirect
    return null;
  }

  return children;
};
